export enum RoutePaths {
  // home
  HOME = '',
  // login
  LOGIN = 'login',
  // forgot password
  FORGOT_PASSWORD = 'forgot-password',
  // register
  REGISTER = 'register',
  // email verification
  EMAIL_VERIFICATION = 'email-verification',
  // reset password
  RESET_PASSWORD = 'reset-password',
  // profile
  PROFILE = 'profile',
  // subscriptions
  SUBSCRIPTIONS = 'subscriptions',
  // prompt
  PROMPT = 'prompt',
  // chat-history
  CHAT_HISTORY = 'chat-history',
  // users
  USERS = 'users',
  USER_DETAILS = 'details/:id',
  // admin
  ADMIN = 'admin',
  // types
  TYPES = 'types',
  // general
  GENERAL = 'general',
  // create sub admin
  CREATE_SUB_ADMIN = 'create-subadmin',
  // unauthorized
  UNAUTHORIZED = 'unauthorized',
  // not found
  NOT_FOUND = 'not-found',
  // settings
  SETTINGS = 'settings',
  // prompt suggestions
  PROMPT_SUGGESTIONS = 'prompt-suggestions',
  // knowldege base
  KNOWLEDGE_BASE = 'knowledge-base',
  // human design
  HUMAN_DESIGN = 'human-design',
  // choose plan
  CHOOSE_PLAN = 'plans',
  // payment
  PAYMENT_METHOD = 'select-payment',
  // payment success
  PAYMENT_SUCCESS = 'payment-success',
  // payment failed
  PAYMENT_FAILED = 'payment-failed',
  // payment cancel
  PAYMENT_CANCEL = 'payment-cancel',
  // payment error
  PAYMENT_ERROR = 'payment-error',
  // payment pending
  PAYMENT_PENDING = 'payment-pending',
  // payment refund
  PAYMENT_REFUND = 'payment-refund',
  // payment chargeback
  PAYMENT_CHARGEBACK = 'payment-chargeback',
  // payment subscription
  PAYMENT_SUBSCRIPTION = 'payment-subscription',
  // plans management
  PLANS = 'plans',

  TRANSACTIONS = 'transactions'
  
}
